module.exports = {
  ...require('./defaults'),
  ...require('./intervals'),
  ...require('./regions'),
  ...require('./wallFrame'),
  ...require('./blockers'),
  ...require('./baseboard'),
  ...require('./openingSides'),
  ...require('./colours'),
  ...require('./casing'),
  ...require('./crown'),
  ...require('./room'),
  ...require('./stickPacking'),
  ...require('./miter'),
};
